import { IImage, INewExitIntentModalFields } from 'marketing-site/@types/generated/contentful'
import { ExitIntentPopupV2 } from 'marketing-site/src/library/components/ExitIntentPopupV2'
import { ContentfulTheme } from 'marketing-site/src/library/elements/Background'
import { transformImage } from 'marketing-site/src/transformers/elements/ContentfulImage'
import React, { ReactNode } from 'react'
import { IPageBehaviorComponentProps } from '../PageBehaviors'
import { ExitIntentModalService } from './ExitIntentModalService'
import { useExitIntentModalTrigger } from './useExitIntentModalTrigger'

const { getStateManager, getIsWrongContentType } = ExitIntentModalService

interface IProps extends IPageBehaviorComponentProps {
  id: string
  children: ReactNode
  modalData: INewExitIntentModalFields | null
}
function ExitIntentModalV2({ id, children, data, modalData }: IProps) {
  const { closeModal, isModalOpen } = useExitIntentModalTrigger(id, data.configuration)
  const stateManager = getStateManager(id)

  const isWrongContentType = getIsWrongContentType(data)
  if (isWrongContentType) {
    throw new Error(
      'Expected exit-intent-modal pageBehavior to reference the newExitIntentModal component',
    )
  }

  const handleModalDismiss = () => {
    stateManager.setModalAsDismissed()
    closeModal()
  }

  if (!modalData) {
    return <></>
  }

  return (
    <>
      {children}
      <ExitIntentPopupV2
        theme={modalData.backgroundColor as ContentfulTheme}
        isOpen={isModalOpen}
        onClose={handleModalDismiss}
        image={transformImage(modalData.imageRef as IImage)}
        checkmarks={modalData.checkmarks}
        headline={modalData.formHeading}
        cta={modalData.cta}
        onCtaClicked={stateManager.setFormAsSubmitted}
      />
    </>
  )
}

const transformPageBehaviorFields = (props: IPageBehaviorComponentProps): IProps => {
  if (!props.data || !props.data.references || !props.data.references[0]) {
    return {
      ...props,
      modalData: null,
    }
  }

  const cmsFields = props?.data?.references[0].fields

  return {
    ...props,
    modalData: cmsFields as unknown as INewExitIntentModalFields,
  }
}

export default (props: IPageBehaviorComponentProps) => (
  <ExitIntentModalV2 {...transformPageBehaviorFields(props)} />
)
